module.exports = __webpack_public_path__ + "static/media/9.c1c5f9ce.jpg";